import type { GetInternalAuditReportDocumentResultsByDocumentIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetInternalAuditReportDocumentAssessmentResultsByDocumentIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetInternalAuditReportDocumentAssessmentResultsByDocumentIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetDocumentInternalAuditResultsByDocumentIdArgs = {
  documentId: string;
};

export const useLazyGetDocumentInternalAuditResultsByDocumentId =
  createLazyQueryHook<
    UseLazyGetDocumentInternalAuditResultsByDocumentIdArgs,
    GetInternalAuditReportDocumentResultsByDocumentIdResponseRow[],
    GetInternalAuditReportDocumentAssessmentResultsByDocumentIdQuery
  >({
    trpcQuery: (client, { documentId }) =>
      client.frontend.internalAuditResult.documentInternalAuditResultsByDocumentId.query(
        { documentId }
      ),
    mapTrpcDataToGraphQL: (data) => ({
      document_internal_audit_result: data,
    }),
    graphqlDocument:
      GetInternalAuditReportDocumentAssessmentResultsByDocumentIdDocument,
    graphqlVariables: ({ documentId }) => ({ ParentId: documentId }),
  });
